import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useWeb3React } from "@web3-react/core";
import "../../splash_event.css";
import axios from "axios";
import { updateLocation } from "../../../../../redux/App/actions";
import { TeddyLandingPage, TeddyRegisterForm } from "./Sections";

export const TeddyDaoCup = () => {
    const dispatch = useDispatch();
    const { page_loaded }= useSelector((state) => state.app);
    const { racerID, accountAddress } = useSelector((state) => state.account);

    const { chainId, account } = useWeb3React();

    if((racerID.length > 1)&&(accountAddress.length > 1)) {
        // dispatch(updateLocation('workshop'));
    }

    const [pageSet, setPage] = useState(false);
    const [currentSplashView, setCurrentSplashView] = useState('');


    function showBaseSplashPage() {
        setCurrentSplashView(<TeddyLandingPage openRegistrationForm={showRegistrationForm} />);
    }

    function showRegistrationForm() {
        setCurrentSplashView(<TeddyRegisterForm closeRegistrationForm={showBaseSplashPage} />);
    }

    document.addEventListener('DOMContentLoaded', function() {

    });

    if(pageSet === false) {
        showBaseSplashPage();
        setPage(true);
    }

    return(<div style={{position:'relative',width:'auto',height:'auto'}}>
    <div className="row black" id="main-landing-page" style={{position:'relative',width:'100%',minHeight:'100vh',position:'relative'}}>
        <div className="hide-on-med-and-down show-on-large-only" style={{position:'absolute',bottom:'0px',right:'0px'}}>
            <span style={{verticalAlign:'bottom'}}><img src="https://media.exiledracers.com/events/teddydao/teddy_dao_bear.jpeg" style={{cursor:'pointer',width:'150px'}} title="Exiled Racers" />
            </span>
            <span>
            <a href="/" className="white-text">
                <img id="exr-logo-button" src="https://media.exiledracers.com/events/teddydao/teddy_dao_cloud.png" style={{cursor:'pointer',width:'55vw'}} title="Exiled Racers" />
            </a>
            </span>
        </div>
        <div className="col s12 transparent" style={{position:'relative',zIndex:'10'}}>
            <div id="splash-main-buttons">
                <div className="col s12">
                    <div className="row" style={{marginBottom:'10px',marginTop:'40px'}}>
                        <div className="col s12 m10 offset-m1 white-text">
                            <div className="center grey-text" style={{fontSize:'30px'}}>
                                The Ultimate Charity Challenge
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginBottom:'40px'}}>
                        <div className="col s12 m10 offset-m1 white-text">
                            <div className="headline-text center" style={{fontSize:'40px',lineHeight:'1'}}>
                                TeddyDAO Charity Tournament
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{margin:'0px',padding:'0px',marginTop:'10px'}}>
                        <div className="col s12 white-text" style={{margin:'0px',padding:'0px'}}>
                            <div className="white-text" style={{width:'100%',height:'1px',background:'#3A3A3A'}}>
                            </div>
                        </div>
                    </div>
                    {currentSplashView}
                    <div className="row show-on-med-and-down hide-on-large-only center" style={{marginTop:'60px',marginBottom:'0px'}}>
                        <span>
                            <img src="https://media.exiledracers.com/events/teddydao/teddy_dao_bear.jpeg" style={{cursor:'pointer',width:'40vw'}} title="Exiled Racers" />
                        </span>
                        <span>
                            <img className="right" id="exr-logo-button" src="https://media.exiledracers.com/events/teddydao/teddy_dao_cloud.png" style={{cursor:'pointer',width:'80vw'}} title="Exiled Racers" />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>);
};